import { render, staticRenderFns } from "./DraggableTeam.vue?vue&type=template&id=6d97d53c&"
import script from "./DraggableTeam.vue?vue&type=script&lang=js&"
export * from "./DraggableTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports